import(/* webpackMode: "eager" */ "/codebuild/output/src2384714272/src/cf-tool-frontend/app/blog/[slug]/page.js");
